import { update } from 'state/util';
import { STATUS } from 'state/requestStatus/reducer';

/**
 * Search query state
 * {
 *   data: [],
 *   status: STAUS.FAILED,
 *   message: "A failure message",
 *
 * Action Dispatch Structure:
 *  {
 *    type: "SEARCH_REQUESTED",
 *    payload: "my search query"
 *  }
 */

// we add page keys to this as we add preferences
const initialState = {
  data: [],
  status: STATUS.NONE,
  message: null,
};

export const searchReducer = (state, action) => {
  if (state === undefined)
    return initialState;

  switch(action.type) {
    case "LOGOUT_REQUESTED":
      return initialState;

    case "SEARCH_REQUESTED":
      return update(state, {
        message: "Loading...",
        status: STATUS.LOADING,
      });

    case "SEARCH_SUCCESSFUL":
      return update(state, {
        data: action.payload.data,
        message: null,
        status: STATUS.COMPLETE,
      });

    case "SEARCH_FAILED":
      return update(state, {
        message: action.payload.message,
        status: STATUS.FAILED,
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/search/reducer.js